import * as React from 'react'
import { useEffect } from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import FacetButton from '~/client/src/shared/components/Filters/components/FacetButton/FacetButton'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import LogisticsSortingOptionsStore from './LogisticsSortingOptions.store'

interface IProps {
  store: LogisticsSortingOptionsStore
  forceClose: boolean
}

const LogisticsSortingOptions: React.FC<IProps> = observer(
  ({ store, forceClose }) => {
    useEffect(() => {
      store.initializeFromStore()
      return () => store.dispose?.()
    }, [store])

    useEffect(() => {
      if (forceClose) {
        store.hideSortingOptions()
      }
    }, [forceClose, store])

    const sortByText = Localization.translator.sortBy
    const label = `${store.sortByIcon} ${sortByText}: ${store.sortByCaption}`

    const renderDropdown = (): JSX.Element => {
      return (
        <div className="tw:absolute tw:top-full tw:left-0 tw:z-[1000] tw:min-w-[180px] tw:bg-popover tw:border tw:border-solid tw:border-border tw:rounded tw:shadow-[0_14px_28px_rgba(0,0,0,0.25),0_10px_10px_rgba(0,0,0,0.25)] tw:mt-0.5">
          <div className="tw:py-1">
            {store.sortingOptions.map(option => (
              <div
                key={option.id}
                className={classList({
                  'tw:flex tw:items-center tw:justify-between tw:px-3 tw:py-2 tw:cursor-pointer tw:text-body-md tw:hover:bg-muted': true,
                  'tw:bg-primary/10 tw:font-medium':
                    store.selectedSortingOptionId === option.id,
                })}
                onClick={() => store.selectSortingOption(option.id)}
              >
                <span>{option.caption}</span>
                {store.selectedSortingOptionId === option.id && (
                  <span className="tw:ml-1 tw:text-muted-foreground tw:text-body-lg tw:font-bold">
                    {store.sortByIcon}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      )
    }

    return (
      <div className="tw:relative tw:inline-block">
        <FacetButton
          type="sort"
          label={label}
          isOpen={store.isShown}
          isActive={!!store.selectedSortingOptionId}
          onClick={store.toggleSortingOptions}
        />
        {store.isShown && renderDropdown()}
      </div>
    )
  },
)

export default LogisticsSortingOptions
